export function MoneyMask(value: number | string | undefined | null): string {
  let Value: number;
  if (!value) {
    Value = 0;
  } else if (typeof value !== "number") {
    Value = parseFloat(value);
    if (Number.isNaN(Value)) {
      return "Sem valor";
    }
  } else {
    Value = value;
  }
  return Value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }).replace("BRL", "R$");
}



// WEBPACK FOOTER //
// ./src/util/Masks/MoneyMask.ts